import { render, staticRenderFns } from "./infoCard.vue?vue&type=template&id=46fb17c4&scoped=true"
import script from "./infoCard.vue?vue&type=script&lang=js"
export * from "./infoCard.vue?vue&type=script&lang=js"
import style0 from "./infoCard.vue?vue&type=style&index=0&id=46fb17c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fb17c4",
  null
  
)

export default component.exports